module.exports = __webpack_public_path__ + "static/media/LOGO-DANFEVIEW.8cd29803.png";